import getSessionStorageApi from 'api/browser/sessionstorage/get';
import setSessionStorageApi from 'api/browser/sessionstorage/set';
import { SESSIONSTORAGE } from 'constants/sessionStorage';

type ComponentImport = () => Promise<any>;

export const lazyRetry = (componentImport: ComponentImport): Promise<any> =>
	new Promise((resolve, reject) => {
		const hasRefreshed: boolean = JSON.parse(
			getSessionStorageApi(SESSIONSTORAGE.RETRY_LAZY_REFRESHED) || 'false',
		);

		componentImport()
			.then((component: any) => {
				setSessionStorageApi(SESSIONSTORAGE.RETRY_LAZY_REFRESHED, 'false');
				resolve(component);
			})
			.catch((error: Error) => {
				// 오프라인 상태에서 window.location.reload()를 부르면 곧바로 브라우저
				// 에러 페이지로의 전체 내비게이션이 되어 SPA가 통째로 이탈한다(F-002).
				// 청크 로드 실패가 네트워크 단절 때문일 수 있으므로, 오프라인일 때는
				// 리로드 대신 온라인 복귀를 기다렸다가 import를 한 번 더 시도한다.
				if (typeof navigator !== 'undefined' && navigator.onLine === false) {
					const retryWhenOnline = (): void => {
						window.removeEventListener('online', retryWhenOnline);
						componentImport().then(resolve).catch(reject);
					};
					window.addEventListener('online', retryWhenOnline);
					return;
				}

				if (!hasRefreshed) {
					setSessionStorageApi(SESSIONSTORAGE.RETRY_LAZY_REFRESHED, 'true');

					window.location.reload();
				}

				reject(error);
			});
	});
